/* eslint-disable import/prefer-default-export */
/* eslint-disable prettier/prettier */
export const SHOW_SEARCHBAR = "SHOW_SEARCHBAR";
export const HIDE_SEARCHBAR = "HIDE_SEARCHBAR";
